import { ErrorType, LoadedType, RequestType } from 'common/actions/referralSettings';

import requestReducerFactory from './requestReducerFactory';

export default requestReducerFactory(RequestType, LoadedType, ErrorType);
